var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 93.15 122.88",
    style: {
      enableBackground: "new 0 0 93.15 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.16,3.37L33.16,0h60l-1.18,3.37c-5.44,0-9.59,1.21-12.46,3.62c-2.88,2.41-5.38,7.45-7.58,15.13l-22.45,78.65 c-1.64,5.57-2.44,9.28-2.44,11.13c0,2.19,0.83,3.86,2.54,5.1c2.17,1.55,6.28,2.41,12.31,2.54l-0.9,3.34H0l0.99-3.34 c6.13,0,10.58-1.18,13.42-3.5c2.85-2.32,5.42-7.42,7.7-15.28l22.64-78.65c1.39-4.83,2.1-8.48,2.1-10.95c0-2.26-0.87-3.99-2.54-5.26 C42.62,4.64,38.57,3.78,32.16,3.37L32.16,3.37L32.16,3.37z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.babb75d7af4f379b8d148ac89b58284c.svg";
export { ForwardRef as ReactComponent };